module.exports = __webpack_public_path__ + "static/ik-1-4b1412d828b9cc21dc3a67257b6dd9eb.png";